/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_GamesInputs */

const th_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการแข่งขันอื่น`)
};

const en_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other fixtures`)
};

const ja_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他の試合`)
};

const zh_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他比赛`)
};

const es_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros partidos`)
};

const pt_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outros jogos`)
};

const id_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertandingan lain`)
};

const fr_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres matchs`)
};

const tl_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iba pang laro`)
};

const vi_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trận khác`)
};

const ko_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다른 경기`)
};

const de_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Spiele`)
};

const ru_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другие матчи`)
};

const tr_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer maçlar`)
};

const it_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altre partite`)
};

const pl_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inne mecze`)
};

const uk_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Інші матчі`)
};

const hi_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्य मैच`)
};

const ar_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباريات أخرى`)
};

const ms_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlawanan lain`)
};

const bn_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্য খেলা`)
};

const zh_tw2_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他比賽`)
};

const zh_hk2_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他比賽`)
};

const ur_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دیگر میچ`)
};

const fa_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی‌های دیگر`)
};

const sw_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michezo mingine`)
};

const nl_other_games = /** @type {(inputs: Other_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere wedstrijden`)
};

/**
* | output |
* | --- |
* | "Other fixtures" |
*
* @param {Other_GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const other_games = /** @type {((inputs?: Other_GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_other_games(inputs)
	if (locale === "ja") return ja_other_games(inputs)
	if (locale === "zh") return zh_other_games(inputs)
	if (locale === "es") return es_other_games(inputs)
	if (locale === "pt") return pt_other_games(inputs)
	if (locale === "id") return id_other_games(inputs)
	if (locale === "fr") return fr_other_games(inputs)
	if (locale === "tl") return tl_other_games(inputs)
	if (locale === "vi") return vi_other_games(inputs)
	if (locale === "ko") return ko_other_games(inputs)
	if (locale === "de") return de_other_games(inputs)
	if (locale === "ru") return ru_other_games(inputs)
	if (locale === "tr") return tr_other_games(inputs)
	if (locale === "it") return it_other_games(inputs)
	if (locale === "pl") return pl_other_games(inputs)
	if (locale === "uk") return uk_other_games(inputs)
	if (locale === "hi") return hi_other_games(inputs)
	if (locale === "ar") return ar_other_games(inputs)
	if (locale === "ms") return ms_other_games(inputs)
	if (locale === "bn") return bn_other_games(inputs)
	if (locale === "zh-TW") return zh_tw2_other_games(inputs)
	if (locale === "zh-HK") return zh_hk2_other_games(inputs)
	if (locale === "ur") return ur_other_games(inputs)
	if (locale === "fa") return fa_other_games(inputs)
	if (locale === "sw") return sw_other_games(inputs)
	if (locale === "nl") return nl_other_games(inputs)
	return en_other_games(inputs)
});